import jwtDecode from "jwt-decode";
import { verify, sign } from "jsonwebtoken";
import axios from "axios";
import axiosInstance from "./axios";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//   }, timeLeft);
// };

const setSession = (accessToken, msTeamsToken, msRefreshToken) => {
  console.log("Set session called", accessToken);
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
    delete axiosInstance.defaults.headers.common.Authorization;
  }
  if (msTeamsToken) {
    localStorage.setItem("ms_accessToken", msTeamsToken);
    axios.defaults.headers.common["MSAuthorization"] = `Bearer ${msTeamsToken}`;
    axiosInstance.defaults.headers.common["MSAuthorization"] = `Bearer ${msTeamsToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem("ms_accessToken");
    delete axios.defaults.headers.common["MSAuthorization"];
    delete axiosInstance.defaults.headers.common["MSAuthorization"];
  }

  if (msRefreshToken) {
    localStorage.setItem("ms_RefreshToken", msRefreshToken);
  }
};

export { verify, sign, isValidToken, setSession };
